import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest,
  HttpHandler, HttpEvent, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  constructor() { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        timeout(15000),
        catchError(

          (error: any) => {

            if (error.error instanceof ErrorEvent) {
              console.error('Client error:', error.error.message);
            } else if (error.name === 'TimeoutError') {
              console.error('Request timed out');
            } else if (error.status === 0) {
              console.error('Network unavailable');
            } else if (error.error && error.error.Message) {
              console.error('Server error:', error.error.Message);
            } else {
              console.error('HTTP error:', error.status, error.statusText);
            }

            return throwError(error);
          }
        )
      )
  };

}
